import { AvatarButtonGroup } from 'src/design-system'
import { CellContext } from '@tanstack/react-table'
import { avatarGroupProps } from 'app/packs/src/utils/user-helpers'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { store } from 'store/index'
import { OrgPersonalSkillsTableRow } from '../data'

export const PeopleCell = observer(
  (data: CellContext<OrgPersonalSkillsTableRow, number>) => {
    const { first3UserIds, userCount } = data.row.original
    const users = first3UserIds.flatMap((id) => store.users.byId(id) || [])

    if (userCount === 0) {
      return <span className="text-gray-400">-</span>
    }

    return (
      <div className="flex items-center gap-2">
        <AvatarButtonGroup
          avatars={avatarGroupProps(users, {
            href: false,
            stateTooltip: true,
          })}
          size="xs"
        />
        {userCount > 3 && (
          <span className="text-gray-500 text-sm">+{userCount - 3}</span>
        )}
      </div>
    )
  }
)
